module.exports = __webpack_public_path__ + "static/media/kids_48.10057940.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_48.jpg
// module id = 5904
// module chunks = 0